import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-shell-admin-warning-banner',
	template: `<div class="alert alert-info">These screens are ADMIN ONLY. You CAN break things here.</div>`,
	styles: [
		`
:host {
	display: block;
	padding: .75rem 1.25rem;
	margin-bottom: 1rem;
	border: 1px solid transparent;
	border-radius: .25rem;
	color: #856404;
	background-color: #fff3cd;
	border-color: #ffeeba;
	margin-top: 1rem;
}`,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})


export class AdminWarningBannerComponent {

}
